export default __webpack_public_path__ + "static/media/order_info.684a30cd.svg";